export type Testimony = {
  testimony: string;
  name: string;
  designation: string;
};

export const testimonials: Testimony[] = [
  {
    testimony:
      "It was a great experience working with Right Sight Research. The service, flexibility and response time to meet my custom requirement, as well as the quality of the report was amazing.",
    name: "Chris Wong",
    designation: "Sales Manager",
  },
  {
    testimony:
      "I highly recommend RSR, they delivered every promise they made.",
    name: "Oliver Barth",
    designation: "Business consultant",
  },
  {
    testimony:
      "The report we received was very impressive. The efforts RSR team took to know our exact requirements were commendable.",
    name: "Jennifer Hopper",
    designation: "Product head",
  },
  {
    testimony:
      "It was indeed a good experience, would definitely recommend and come back for future prospects.",
    name: "Mike Lee",
    designation: "Corporate researcher",
  },
];
